import { Outlet } from "react-router-dom";
import useDeviceOrientation from "./hooks/useDeviceOrientation";

const Layout = () => {
  const { isPortrait } = useDeviceOrientation();

  return (
    <main className={isPortrait ? "tvpc-m-port" : "tvpc-m-land"}>
      <div className="content">
        <Outlet />
      </div>
    </main>
  );
};

export default Layout;
